import { z } from "zod";

import { api } from "~/api";
import { createServiceResponseSchema } from "../schemas";
import { insuranceSchema } from "./schemas";

export const insurancesDataModelSchema = z.array(insuranceSchema);

export type GetInsurancesListParams = {
  stateId: number;
  eligibility?: string[];
};

export const getInsurancesList = async ({
  stateId,
  eligibility,
}: GetInsurancesListParams) => {
  const response = await api.get(`/states/${stateId}/insurances`, {
    params: { eligibility },
  });

  return createServiceResponseSchema(insurancesDataModelSchema).parse(
    response.data,
  ).data;
};
